import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";

const Pie = props => {
  const [options, setOptions] = useState({});
  const [series, setSeries] = useState([]);

  useEffect(() => {
    if (!props || !props.categories) return;

    setOptions({
      chart: {
        width: 380,
        type: 'pie',
      },
      labels: props.categories,
      responsive: [
        {
          breakpoint: 100,
          options: {
            chart: {
              width: 100
            },
            legend: {
              position: "bottom"
            }
          }
        }
      ]
    });

    setSeries(props.series);
  }, [props]);

  return <Chart options={options} series={series} type="pie" width={380} />;
};

export default Pie;
